// @flow
import Main from './components/Main'
export default () => ({
  path: 'suspended-accts',
  element: <Main />,
})
